import { CONSTANTS } from '@/types/enum/constants'

/**
 * Acces a l'ESPACE INDUSTRY (« Espace <Labo> », routes industryoffice/group) — deux
 * conditions cumulatives (l'espace n'est plus derriere un feature flag) :
 *
 *  1. la COMPANY a l'espace personnalise active (fiche entreprise, flag admin) ;
 *  2. l'UTILISATEUR est habilite a l'espace : il porte ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_ENTITY_GROUP,
 *     que l'API (User::getRoles, bloc #GROUP INDUSTRY) ne pose QUE pour la hierarchie de
 *     l'espace — Administrateur (ex-Siege) / DR / DP — et les porteurs du pouvoir d'owner
 *     (owner de la fiche, share owner). Un role module (Prestataire PMI / School / Store,
 *     SFTP, contrats...) n'ouvre PAS l'espace : sans ce 2e critere, ces profils voyaient le
 *     selecteur d'espace et demarraient sur un espace labo entierement grise.
 *
 * Meme garde que fnDisplayIndustryNav (cf getIndustryOfficeGroupIndustry) et que le
 * gate des routes industryoffice/group (roles: ENTITY_GROUP). Consommee par le selecteur
 * d'espace (useRouteActive), IndustryRoleContext (redirect hors espace) et les routes.
 */
export const canAccessEspaceIndustry = (dataMyProfile: any): boolean =>
  !!dataMyProfile?.selectCompanyDefault?.activeEspacePersonnalise &&
  !!(dataMyProfile?.loggedUserRoles || dataMyProfile?.roles)?.includes(
    CONSTANTS.ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_ENTITY_GROUP
  )
